<script>
import {VueMaskDirective as mask} from 'v-mask'
import ClickOut from '../../../../../utils/directives/clickout'

export default {
  name: 'DataFiltroSelect',
  directives: {mask, ClickOut},
  data () {
    return {
      data1: null,
      data2: null
    }
  },
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      required: false,
      default: () => 'Label'
    }
  },
  computed: {
    model: {
      get () {
        return this.value === null ? null : this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    isPeriodo () {
      return this.model === 'Periodo'
    }
  },
  watch: {
    isPeriodo () {
      if (this.isPeriodo) return
      this.data1 = null
      this.data2 = null
    }
  },
  methods: {
    change () {
      const {data1, data2} = this
      this.$emit('change', {data1, data2})
    }
  }
}
</script>

<template>
  <div class="form-group">
    <label class="title_filter " for="filtroData">{{ label }}</label>
    <select id="filtroData" @change="$emit('change')" v-model="model" class="form-control">
      <option :value="null">Qualquer data</option>
      <option :value="'Hoje'">Hoje</option>
      <option :value="'7dias'">Últimos 7 dias</option>
      <option :value="'Mes'">Este mês</option>
      <option :value="'Ano'">Este ano</option>
      <option :value="'Periodo'">Período</option>
    </select>
    <transition name="fade">
      <div class="filtros-periodo-datas-container" v-if="isPeriodo">
        <div class="filtros-periodo-datas form-group">
          <input id="filtroData1"
                 placeholder="dd/mm/yyyy"
                 v-model="data1"
                 v-mask="'##/##/####'"
                 type="text"
                 class="form-control"
          />
          <span class="m-l m-r">até</span>
          <input id="filtroData2"
                 placeholder="dd/mm/yyyy"
                 v-model="data2"
                 v-mask="'##/##/####'"
                 type="text"
                 class="form-control"
          />
          <button class="btn btn-sm btn-info m-l" @click="change" :disabled="!data1 || !data2">Pesquisar</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.filtros-periodo-datas-container {
  position: absolute;
  background: white;
  width: 500px;
  margin: 10px 0;
  box-shadow: 0 1px 8px rgba(0, 0, 0, .53);
  border-radius: 7px;
  padding: 20px;
  z-index: 10;
}
.filtros-periodo-datas {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .1s;
}
/* .fade-leave-active em versões anteriores a 2.1.8 */
.fade-enter, .fade-leave-to  {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// DataFiltroSelect.vue?674ac8fa